import {Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {AlertComponent, AlertOptions} from '@shared/components/alert/alert.component';
import {TranslateService, Translation} from '@ngx-translate/core';
import {PatientService} from '@core/services/patient.service';
import {AlertTypes} from '@core/enums/alert-types';

@UntilDestroy()
@Component({
  selector: 'ncp-edit',
  imports: [
    AlertComponent
  ],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class EditComponent implements OnInit {

  private readonly translate = inject(TranslateService);
  private readonly patientService = inject(PatientService);
  protected translations!: Translation;
  protected alertText = '';

  protected editAlertOptions = signal<AlertOptions>({
    id: 'editAlert',
    type: AlertTypes.info,
    title: 'patient_record_version',
    show: true,
  });

  ngOnInit() {
    this.translations = this.translate.instant('alert');
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('alert');

      this.alertText = this.translations['draft'];
    });

    this.alertText = this.translations['draft'];
  }
}
